import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'

import { Box, Button, Card, Divider, Grid, Typography } from '@material-ui/core'
import {
  PlusCircle as PlusCircleIcon,
  Settings as SettingsIcon,
} from 'react-feather'
import { isEmpty } from 'lodash'

import { AuditCard, AutomationModal } from './components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'
import useSnackbar from 'hooks/useSnackbar'

import constants from 'constants/index'
import { routes } from 'Routes'
import useStyles from './styles'

const EvaluationStep = () => {
  const history = useHistory()
  const classes = useStyles()
  const snackbar = useSnackbar()
  const {
    wantsToAdvanceStep,
    isShow,
    isPreAvaliation,
    handleNext,
    resetAdvanceStep,
    companySupplier,
  } = useThirdPartyManagementStepper()

  const { STEPS } = constants.tours.thirdPartyManagements

  const progressStatusId = isShow
    ? isPreAvaliation
      ? STEPS.PRE_AVALIATION.SHOW.EVALUATION[2]
      : STEPS.SHOW.EVALUATION[2]
    : isPreAvaliation
    ? STEPS.PRE_AVALIATION.CREATION.EVALUATION[3]
    : STEPS.CREATION.EVALUATION[3]

  const auditCardsBoxId = isShow
    ? isPreAvaliation
      ? STEPS.PRE_AVALIATION.SHOW.EVALUATION[3]
      : STEPS.SHOW.EVALUATION[3]
    : isPreAvaliation
    ? STEPS.PRE_AVALIATION.CREATION.EVALUATION[4]
    : STEPS.CREATION.EVALUATION[4]

  const audits = companySupplier?.companySupplierAudits || []

  const { COMPLETED_PROGRESS_STATUS, INACTIVE_STATUS } =
    constants.companySuppliers

  const hasActiveAudit = audits.some(
    (audit) =>
      audit?.progressStatus !== COMPLETED_PROGRESS_STATUS &&
      audit?.status !== INACTIVE_STATUS,
  )

  const [openAutomation, setOpenAutomation] = useState(false)

  useEffect(() => {
    if (!wantsToAdvanceStep || isShow) return

    if (isEmpty(audits)) {
      snackbar.open({
        message: 'É necessário criar uma auditoria para avançar de etapa.',
        variant: 'error',
      })
      resetAdvanceStep()
      return
    }

    handleNext()
    resetAdvanceStep()
  }, [wantsToAdvanceStep])

  const handleNewAudit = () => {
    if (hasActiveAudit) {
      snackbar.open({
        message:
          'Não é possível criar uma nova auditoria com outra em andamento.',
        variant: 'error',
      })
      return
    }

    history.push(
      reverse(routes.thirdPartyManagements.mySuppliers.audit.new, {
        companySupplierId: companySupplier?.id,
      }),
    )
  }

  return (
    <Card>
      <Box className={classes.header}>
        <Typography variant="h5">Histórico de Auditorias</Typography>
        {!isShow && (
          <Box display="flex" gridGap={8}>
            <Button
              variant="outlined"
              onClick={() => setOpenAutomation(true)}
              startIcon={<SettingsIcon size={18} />}
            >
              Configurar Automação
            </Button>
            <Button
              id={
                isPreAvaliation
                  ? STEPS.PRE_AVALIATION.CREATION.EVALUATION[2]
                  : STEPS.CREATION.EVALUATION[2]
              }
              variant="contained"
              color="primary"
              onClick={handleNewAudit}
              startIcon={<PlusCircleIcon size={18} />}
            >
              Nova Auditoria
            </Button>
          </Box>
        )}
      </Box>

      <Divider />

      {isEmpty(audits) ? (
        <Box display="flex" justifyContent="center" alignItems="center" p={4}>
          <Typography variant="body1" color="textSecondary">
            Nenhuma auditoria encontrada
          </Typography>
        </Box>
      ) : (
        <Grid
          id={auditCardsBoxId}
          container
          spacing={2}
          className={classes.cards}
        >
          {audits.map((audit, index) => (
            <Grid item xs={12} md={6} key={audit.id}>
              <AuditCard
                audit={audit}
                auditsCount={audits.length}
                progressStatusId={index === 0 ? progressStatusId : undefined}
              />
            </Grid>
          ))}
        </Grid>
      )}

      {openAutomation && (
        <AutomationModal open={openAutomation} setOpen={setOpenAutomation} />
      )}
    </Card>
  )
}

export default EvaluationStep
